import React from 'react'
import styled from '@emotion/styled'
import { iconSet } from '../icons'
import { MultiButton } from '../buttons'
import * as mixins from '../../styles/mixins'
import * as constants from 'view/styles/constants'
import { SlidingPanel } from './SlidingPanel'
import { IconLabel } from '../icons/IconLabel'

interface CollapsePanelProps {
  className?: string
  title: string
  subtitle?: string
  defaultCollapsed?: boolean
  dataTestId?: string
  children?: React.ReactNode
}

const CollapsePanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

const CollapsePanelRight = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const CollapsePanelButton = styled(MultiButton)`
  ${mixins.flexCenterContentCrossAxis};
  justify-content: space-between;
  background-color: ${constants.CORE_PRIMARY_1};
  width: 100%;
  padding-right: 19px;
`

const CollapseIcon = styled(IconLabel)<{ collapsed?: boolean }>`
  color: ${constants.CORE_PRIMARY_4};
  svg {
    width: 8px;
    transform: rotate(${props => (props.collapsed ? 0 : '180deg')});
  }
`

const CollapsePanelTitle = styled.span`
  ${mixins.flexCenterContentCrossAxis};
  flex: 1 1 auto;
  font-weight: ${constants.FontWeight.SemiBold};
  font-size: 12px;
  padding-left: 19px;
  height: 30px;
`
const CollapsePanelSubtitle = styled.span`
  ${mixins.flexCenterContentCrossAxis};
  color: ${constants.ACCENT_PRIMARY};
  font-size: 12px;
  margin-right: 6px;
  height: 30px;
`
const CollapsePanelContent = styled(SlidingPanel)<{}>`
  flex: 1 1 auto;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
`

interface CollapsePanelState {
  collapsed: boolean
}

export class CollapsePanel extends React.Component<CollapsePanelProps, CollapsePanelState> {
  state = { collapsed: this.props.defaultCollapsed === undefined ? true : this.props.defaultCollapsed }
  render() {
    const { children, className, title, subtitle, dataTestId } = this.props
    const { collapsed } = this.state

    return (
      <CollapsePanelWrapper className={className} data-test-id={dataTestId}>
        <CollapsePanelRight>
          <CollapsePanelButton onClick={this.toggleCollapsed}>
            <CollapsePanelTitle>{title}</CollapsePanelTitle>
            <CollapsePanelSubtitle>{subtitle}</CollapsePanelSubtitle>
            <CollapseIcon icon={iconSet.chevronDown} collapsed={collapsed} />
          </CollapsePanelButton>
          <CollapsePanelContent closed={collapsed} transitionOnAppear={false}>
            {children}
          </CollapsePanelContent>
        </CollapsePanelRight>
      </CollapsePanelWrapper>
    )
  }

  toggleCollapsed = () => {
    this.setState({ collapsed: !this.state.collapsed })
  }
}
